export default __webpack_public_path__ + "static/media/hyundai.18c6c0cc.svg";